
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/create-new-teaching-account",
      function () {
        return require("private-next-pages/create-new-teaching-account.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/create-new-teaching-account"])
      });
    }
  